export function setMenus(menus){
  return {
    type:'SET_MENUS',
    menus
  }
}

export function setRoles(roles){
  return {
    type:'SET_ROLES',
    roles
  }
}

export function setOperator(operator){
  return {
    type:'SET_OPERATOR',
    operator
  }
}

export function setRoleId(roleId){
  return {
    type:'SET_ROLEID',
    roleId
  }
}